import React, { memo } from 'react';

import { IconColor } from '../../../types/IconColor';
import { SharedInfoCardProps } from '../../../types/SharedInfoCardProps';
import { Badge } from '../../Badge/Badge';
import { Button } from '../../Button/Button';
import { Icon } from '../../Icon/Icon';
import { Layout } from '../../Layout/Layout';
import { Markdown } from '../../Markdown/Markdown';
import { Text } from '../../Text/Text';
import { Card } from '../Card';

export const InfoCard = memo(
  ({
    action,
    description,
    icon,
    iconStatus,
    number,
    size = 'm',
    status,
    title,
  }: SharedInfoCardProps) => {
    let indicator: React.ReactNode = null;
    if (icon) {
      let content: IconColor | undefined = undefined;
      if (iconStatus) {
        content = `status.${iconStatus}` as IconColor;
      } else if (status) {
        content = `status.${status}` as IconColor;
      }
      indicator = <Icon color={content} icon={icon} size="l" />;
    } else if (number) {
      indicator = <Badge status={status} number={number} />;
    }

    return (
      <Card size={size} status={status}>
        <Layout align="center" direction="column" preset="l">
          {indicator}
          <Text textAlign="center" variant="section">
            {title}
          </Text>
          {description && <Markdown text={description} textAlign="center" />}
          {action && (
            <Button {...action} variant={action.level ?? 'secondary'} />
          )}
        </Layout>
      </Card>
    );
  },
);
